import regex from 'common/utils/regex';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import RedirectLoginButton from './redirect-login-button';
import RetryButton from './retry-button';
import Text from '../text';

export interface ScaffoldViewComponentProps {
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  message?: string | React.ReactNode;
  additionalContent?: React.ReactNode;
  onRetry?: () => void;
  isLoading?: boolean;
  isShowRedirectLogin?: boolean;
  isShowCloseTab?: boolean;
}

export default function ScaffoldViewComponent(
  props: ScaffoldViewComponentProps,
) {
  const { t } = useTranslation();
  const regexChecker = React.useCallback(
    (value: string) => {
      if (regex.locale.test(value)) {
        return t(value);
      }
      return value;
    },
    [t],
  );
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
      }}
    >
      {typeof props.title === 'string' ? (
        <Text variant="title1Bold" textAlign="center">
          {regexChecker(props.title)}
        </Text>
      ) : (
        props.title
      )}
      {typeof props.subtitle === 'string' ? (
        <Text variant="title2Bold" textAlign="center">
          {regexChecker(props.subtitle)}
        </Text>
      ) : (
        props.subtitle
      )}
      {typeof props.message === 'string' ? (
        <Text variant="ParagraphLarge" textAlign="center">
          {regexChecker(props.message)}
        </Text>
      ) : (
        props.message
      )}
      {props.additionalContent}
      {props.isShowRedirectLogin && <RedirectLoginButton />}
      {props.onRetry && (
        <RetryButton isLoading={props.isLoading} onRetry={props.onRetry} />
      )}
    </div>
  );
}
